import axios from 'axios';

// 生成PDF异步任务
export const exportPdfAPI = async (fileId, fName, userInfo, handleLogOut, message) => {
    return axios({
        url: `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/create/${fileId}`,
        method: 'POST',
        headers: {
            DeviceType: '3',
            fileId: fileId,
            token: userInfo.token,
            userId: userInfo.userId,
            spaceId: userInfo.spaceId,
            deviceId: userInfo.deviceId
        },
        data: {
            exportFormat: 'PDF'
        },
        withCredentials: true // 添加 withCredentials 选项
    });
};

// fileSocket接受推送后下载PDF
export const downloadPDFAPI = async (fileId, downloadId, fName, userInfo, handleLogOut, message) => {
    return axios({
        url: `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/pdf/download/${downloadId}`,
        method: 'GET',
        headers: {
            fileId: fileId,
            token: userInfo.token,
            userId: userInfo.userId,
            spaceId: userInfo.spaceId,
            deviceId: userInfo.deviceId
        },
        responseType: 'blob',
        withCredentials: true // 添加 withCredentials 选项
    }).then(response => {
        // 处理返回的文件流
        const blob = response.data;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        // 确保文件名以 .pdf 结尾
        let fileName = fName || '导出文件';
        if (!fileName.endsWith('.pdf')) {
            fileName += '.pdf';
        }
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        window.setTimeout(function () {
            URL.revokeObjectURL(blob);
            document.body.removeChild(link);
        }, 0);
        message.success('文件生成成功');
    }).catch((err) => {
        if (err.response.status === 401) {
            handleLogOut()
            return
        }
        console.log(err, 'err')
        message.error('文件生成失败')
    })
};

// 导出成功后下载 office 文件（blob 方式，保证文件名和扩展名正确）
export const downloadOfficeAPI = async (downloadId, userInfo, handleLogOut, message, fileName) => {
    return axios({
        url: `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/download/${downloadId}`,
        method: 'GET',
        headers: {
            token: userInfo.token,
            userId: userInfo.userId,
            spaceId: userInfo.spaceId,
            deviceId: userInfo.deviceId,
        },
        responseType: 'blob',
        withCredentials: true,
    }).then(response => {
        const blob = response.data;
        const disposition = response.headers['content-disposition'] || '';
        const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
        const resolvedFileName = fileName || (match ? decodeURIComponent(match[1]) : 'exported_file');
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = resolvedFileName;
        document.body.appendChild(link);
        link.click();
        window.setTimeout(() => {
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
        }, 0);
        message.success('文件生成成功');
    }).catch(err => {
        if (err.response?.status === 401) {
            handleLogOut();
            return;
        }
        message.error('文件生成失败');
    });
};

export const downloadZipAPI = async (downloadId, userInfo, message) => {
    const url = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD_URL}/public/download/zip/${downloadId}`;
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('target', '_self');
    document.body.appendChild(link);
    link.click();
    setTimeout(() => document.body.removeChild(link), 200);
    // return axios({
    //     url: `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/download/zip/${downloadId}`,
    //     method: 'GET',
    //     headers: {
    //         token: userInfo.token,
    //         userId: userInfo.userId,
    //         spaceId: userInfo.spaceId,
    //         deviceId: userInfo.deviceId,
    //     },
    //     responseType: 'blob',
    //     withCredentials: true,
    // }).then(response => {
    //     const blob = response.data;
    //     const disposition = response.headers['content-disposition'] || '';
    //     const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
    //     const fileName = match ? decodeURIComponent(match[1]) : (downloadId + '.zip');
    //     const link = document.createElement('a');
    //     link.href = URL.createObjectURL(blob);
    //     link.download = fileName;
    //     document.body.appendChild(link);
    //     link.click();
    //     window.setTimeout(() => {
    //         URL.revokeObjectURL(link.href);
    //         document.body.removeChild(link);
    //     }, 0);
    //     // message.success('文件压缩完成，正在下载');
    // }).catch(err => {
    //     console.error('[downloadZipAPI]', err);
    //     message.error('文件下载失败');
    // });
    // message.success('文件压缩完成，正在下载');
};

// 查询导出任务状态（长轮询）
export const getExportStatusAPI = async (downloadId, userInfo) => {
    return axios({
        url: `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD}/stream/api/public/export/status/${downloadId}`,
        method: 'GET',
        headers: {
            token: userInfo.token,
            userId: userInfo.userId,
            spaceId: userInfo.spaceId,
        },
        withCredentials: true
    });
};

export const exportHTMLAPI = async (data, handleLogOut) => {
    const { message } = data
    try {
        const res = await axios({
            url: `${process.env.VUE_APP_CLOUD_BFF}/wiki/export/html`,
            method: 'POST',
            data,
            withCredentials: true // 添加 withCredentials 选项
        })
        if (res.data.code === 200) {
            return res.data.data;
        }
        else {
            if (res.status === 401) {
                handleLogOut();
                return '';
            } else {
                return '';
            }
        }
    } catch (err) {
        return '';
        console.log(err, 'err')
    }
};
